module.exports = __webpack_public_path__ + "static/media/IMG_0017.a0508a88.jpg";